import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { BrandHeader } from "../../components/BrandHeader";
import { teamApi } from "../../lib/teamApi";

export function TokenExchangePage({ surface }: { surface: "organiser" | "participant" }) {
  const location = useLocation(); const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const token = new URLSearchParams(location.search).get("token") ?? "";
    history.replaceState({}, "", location.pathname);
    teamApi(`/api/team/${surface}/exchange`, { method: "POST", body: JSON.stringify({ token }) })
      .then(() => navigate(surface === "organiser" ? "/team/workspace" : "/team/participant", { replace: true }))
      .catch(() => setFailed(true));
  }, [location.pathname, location.search, navigate, surface]);
  return <div className="page-shell team-page"><BrandHeader /><main className="content-shell team-token-state" role={failed ? "alert" : "status"}><p className="eyebrow">Secure access</p><h1>{failed ? "This link is no longer valid" : "Verifying your secure link…"}</h1><p className="lead">{failed ? "Request a new link and try again." : "This should only take a moment."}</p></main></div>;
}
